import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import { useAuth } from '../context/AuthContext';
import logo from '../assets/PM_Logo.svg';

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';
const API_BASE = (process.env.REACT_APP_API_BASE || 'https://backend.parthmerchant.com').replace(/\/$/, '');

export default function Login() {
  const navigate = useNavigate();
  const { isAuthed, signIn } = useAuth();
  const [error, setError]     = useState(null);
  const [loading, setLoading] = useState(false);

  // Already signed in → skip the login screen.
  useEffect(() => {
    if (isAuthed) navigate('/overview', { replace: true });
  }, [isAuthed, navigate]);

  const handleSuccess = async (credentialResponse) => {
    setLoading(true);
    setError(null);
    try {
      const res = await fetch(`${API_BASE}/api/auth/verify-google`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ credential: credentialResponse.credential }),
      });
      if (res.status === 403) {
        setError('Access denied. This admin area is restricted.');
        return;
      }
      if (!res.ok) {
        setError('Verification failed. Please try again.');
        return;
      }
      // Backend confirmed: valid Google token + correct admin email.
      signIn(credentialResponse.credential);
      navigate('/overview');
    } catch {
      setError('Could not reach the server. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleError = () => setError('Sign-in failed. Try again.');

  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <div className="sa-login-page">
        <div className="sa-login-aura">
          <div className="orb orb-1" />
          <div className="orb orb-2" />
        </div>
        <div className="admin-card sa-login-card">
          <img src={logo} className="sa-login-logo" alt="Parth Merchant" />
          <div className="admin-header">
            <span className="section-label">Admin</span>
            <h1 className="admin-title">Parth Merchant</h1>
            <p className="admin-desc">
              Sign in to manage the blog, grid, main page and site theme.
            </p>
          </div>

          <div className="admin-sso">
            {loading ? (
              <p className="admin-desc">Verifying…</p>
            ) : (
              <GoogleLogin
                onSuccess={handleSuccess}
                onError={handleError}
                theme="filled_black"
                shape="pill"
                size="large"
                text="signin_with"
              />
            )}
          </div>

          {error && <p className="admin-error">{error}</p>}
        </div>
      </div>
    </GoogleOAuthProvider>
  );
}
